export default __webpack_public_path__ + "static/media/1257.b9ef7323.png";